/* eslint-disable */
var appConfig = require('webpack-config-loader!../app-config.js');
/* eslint-enable */

const URL = appConfig.scApiUrl;
const LBCX = appConfig.f3ApiUrl;

module.exports = {
  Actions : {
      rootUrl: URL,
      api: URL+'api/',
      apiAuth: URL+'auth/',
      f3: LBCX,
  },
}



/** WEBPACK FOOTER **
 ** ./src/utils/CommonConstants.js
 **/